import { api } from '../utils/api';

const CACHE_KEYS = {
  CAKES: 'app_cakes_cache',
  CATEGORIES: 'app_categories_cache'
};

const CACHE_DURATION = 60 * 60 * 1000; // 1 hour in milliseconds

export const getCachedCakes = () => {
  try {
    const cached = localStorage.getItem(CACHE_KEYS.CAKES);
    if (!cached) return null;
    
    const { data, timestamp } = JSON.parse(cached);
    
    // Check if cache is expired
    if (Date.now() - timestamp > CACHE_DURATION) {
      console.log('Cakes cache expired');
      return null;
    }
    
    return data;
  } catch (e) {
    console.error('Error reading cakes cache:', e);
    return null;
  }
};

export const getCachedCategories = () => {
  try {
    const cached = localStorage.getItem(CACHE_KEYS.CATEGORIES);
    if (!cached) return null;

    const { data, timestamp } = JSON.parse(cached);
    
    // Check if cache is expired
    if (Date.now() - timestamp > CACHE_DURATION) {
      console.log('Categories cache expired');
      return null;
    }

    return data;
  } catch (e) {
    console.error('Error reading categories cache:', e);
    return null;
  }
};

// Fetch all cakes
export const fetchCakes = async () => {
  try {
    const data = await api.get('/cakes.php');
    
    console.log('Raw API response:', JSON.stringify(data).substring(0, 500));
    console.log('data.success:', data.success);
    console.log('data.data:', data.data);
    console.log('data.data.cakes:', data.data?.cakes);
    
    if (data.success && data.data && data.data.cakes) {
      // Filter out cakes from "store" category
      const filteredCakes = data.data.cakes.filter(cake => 
        !cake.category_name || cake.category_name.toLowerCase() !== 'store'
      );
      
      console.log('Returning cakes:', filteredCakes.length);
      
      // Update cache with timestamp
      localStorage.setItem(CACHE_KEYS.CAKES, JSON.stringify({
        data: filteredCakes,
        timestamp: Date.now()
      }));
      
      return filteredCakes;
    }
    
    console.log('No cakes found in response, returning empty array');
    return [];
  } catch (error) {
    console.error('Error fetching cakes:', error);
    return [];
  }
};

// Fetch all addons
export const fetchAddons = async () => {
  try {
    const data = await api.get('/addons.php');
    
    if (data.success) {
      return data.data.addons || [];
    }
    return [];
  } catch (error) {
    console.error('Error fetching addons:', error);
    return [];
  }
};

// Fetch categories with hierarchical structure
export const fetchCategories = async () => {
  try {
    const data = await api.get('/categories.php');
    
    console.log('Categories API response:', data);
    
    if (data.success && data.data && data.data.hierarchical) {
      // Return hierarchical categories (includes subcategories)
      // Filter out "store" category
      // Filter out "store" category
      const filteredCategories = data.data.hierarchical.filter(cat => cat.name.toLowerCase() !== 'store');
      
      // Sort categories by ID descending (Recent first) - Same as Home.js
      const sortedCategories = filteredCategories.sort((a, b) => b.id - a.id);
      
      // Update cache with timestamp
      localStorage.setItem(CACHE_KEYS.CATEGORIES, JSON.stringify({
        data: sortedCategories,
        timestamp: Date.now()
      }));
      
      return sortedCategories;
    }
    
    return [];
  } catch (error) {
    console.error('Error fetching categories:', error);
    return [];
  }
};

// Get unique categories from cakes
export const getCategoriesFromCakes = (cakes) => {
  const categoryMap = new Map();
  
  cakes.forEach(cake => {
    if (cake.category_id && cake.category_name) {
      categoryMap.set(cake.category_id, {
        id: cake.category_id,
        name: cake.category_name
      });
    }
  });
  
  return Array.from(categoryMap.values());
};

// Filter cakes by category
export const filterCakesByCategory = (cakes, categoryId) => {
  if (categoryId === 'all') return cakes;
  return cakes.filter(cake => cake.category_id === parseInt(categoryId));
};

// Get cake by ID
export const getCakeById = (cakes, id) => {
  return cakes.find(cake => cake.id === parseInt(id));
};

// Get image URL
export const getImageUrl = (imagePath) => {
  if (!imagePath) return null;
  if (imagePath.startsWith('http')) return imagePath;
  return `https://panel.supplebakes.com/${imagePath}`;
};
